import styled from 'styled-components';

export const IconContainer = styled.span`
  position: relative;
  vertical-align: middle;
  margin-left: 6px;
`;
